import { SectionHeading } from './SectionHeading';
import { EngagementCard } from './EngagementCard';
import styles from './EngagementSection.module.css';
export function EngagementSection() {
  return (
    <section className={styles.section}>
      <SectionHeading
        eyebrow="Сотрудничество"
        title="Формат работы под вашу задачу"
        description="Стоимость зависит от объёма, числа площадок и особенностей объекта. Согласуем её в коммерческом предложении."
      />
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <EngagementCard
          title="Инвентаризация"
          description="Независимая проверка имущества и запасов на ваших объектах."
          features={[
            'Товарно-материальные запасы',
            'Основные средства и оборудование',
            'Сверка с бухгалтерским учётом',
            'Анализ выявленных расхождений',
            'Итоговый отчёт и рекомендации',
          ]}
        />
        <EngagementCard
          title="Аудит и аналитика"
          description="Проверка финансовой отчётности и материалы для управленческих решений."
          featured
          features={[
            'Проверка по МСФО и НСФО',
            'Достоверность отчётных данных',
            'Структурированные результаты',
            'Рекомендации по учётным процессам',
            'Презентация итогов проверки',
          ]}
        />
      </div>
    </section>
  );
}
